import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tree } from 'primereact/tree';

const atcCodesView = (props) => {


	return (
		<Tree
			value={props.treeAtcCodes}
			style={{ width: "100%" }}
			selectionMode="single"
			selectionKeys={props.selectionKeys}
			onSelectionChange={e => props.handleSelectionChange(e.value)}
			onContextMenu={props.onContextMenu}
		/>
	)
}

export default atcCodesView;
